import { useEffect, MutableRefObject } from 'react';

const useWrapTables = (ref: MutableRefObject<HTMLDivElement | null>) => {
	useEffect(() => {
		if (ref.current) {
			const tables = ref.current.querySelectorAll('table');
			tables.forEach(table => {
				const wrapper = document.createElement('div');
				wrapper.className = 'table-wrapper';

				table.parentNode?.insertBefore(wrapper, table);
				wrapper.appendChild(table);
			});
		}
	}, [ref]);
};

export default useWrapTables;



